module.exports = __webpack_public_path__ + "media/images/pict-e78adfd29f2920cf15433d62a54f733e.png";